import * as Yup from 'yup';

const DeviceTypeSchema = (t: (key: string) => string) =>
  Yup.object().shape({
    name: Yup.string().required(t('general_errors.required')),
    category: Yup.string().required(t('general_errors.required')),
    manufacturer: Yup.string().nullable(),
    description: Yup.string(),
    model_name: Yup.string(),
    model_number: Yup.string(),
    image: Yup.mixed().nullable(),
    hardware_id: Yup.string()
  });

export default DeviceTypeSchema;
